import { React, useState, useRef, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { urlFor } from '../utils/sanity/urlFor';

import { useDispatch } from 'react-redux';
import { setNavbarHeight } from '../redux/store';

function Navbar({ logo }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen((prevState) => !prevState);
  const dispatch = useDispatch();

  const navLogo = logo[0].portfolioNavLogo
  const navbarRef = useRef(null);

  useEffect(() => {
    dispatch(setNavbarHeight(navbarRef.current.offsetHeight));
  }, [dispatch]);

  return (
    <header  ref={navbarRef} className="md:static pt-8 sm:pt-16 pb-5 sm:pb-14 w-full max-w-screen px-8 xl:px-40 md:px-10">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto">
        <Link to="/" className="hover:opacity-60 flex items-center">
          {navLogo && (
            <picture>
              <img src={urlFor(navLogo)} alt="Portfolio logo" className="w-8 md:w-12" />
            </picture>
          )}
          <span className="self-center text-xl  md:text-2xl ml-2 font-semibold whitespace-nowrap dark:text-white">
            Portfolio
          </span>
        </Link>

        <nav
          className={`hidden md:flex md:justify-end md:items-center md:mr-3 main-font font-semibold items-center text-xs nav-text-spacing text-black justify-center mt-2`}
        >
          <NavLink
            to="/"
            className="block mt-4 md:inline-block md:mt-0 hover:text-emerald-400"
            activeclassname="font-bold"
          >
            HOME
          </NavLink>
          <NavLink
            to="/portfolio"
            className="block mt-4 ml-10 md:inline-block md:mt-0 hover:text-emerald-400"
            activeclassname="font-bold"
          >
            PORTFOLIO
          </NavLink>
          <NavLink
            to="/contactMe"
            className="block mt-4 ml-10 md:inline-block md:mt-0 hover:text-emerald-400"
            activeclassname="font-bold"
          >
            CONTACT ME
          </NavLink>
        </nav>
        <button
          type="button"
          className="md:hidden inline-flex items-center p-1 ml-3 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          onClick={toggleMenu}
          aria-label="Open main menu"
          aria-expanded={isMenuOpen}
        >
          <svg
            className="w-6 h-6 fill-current menu-icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isMenuOpen ? (
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4.5L5.5 3L12 9.5L18.5 3L20 4.5L13.5 11L20 17.5L18.5 19L12 12.5L5.5 19L4 17.5L10.5 11L4 4.5Z"
              />
            ) : (
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 6H20V8H4V6ZM4 11H20V13H4V11ZM4 16H20V18H4V16Z"
              />
            )}
          </svg>
        </button>
      </div>
      <div className={`md:hidden w-full ${isMenuOpen ? 'block' : 'hidden'}`} id="navbar-hamburger">
        <ul className="flex flex-col font-medium main-font mt-4 rounded-sm dark-background-color text-white text-center dark:border-gray-700">
          <li className="mx-8">
            <NavLink
              to="/"
              className="block py-2 pl-3 pr-4 text-white"
              activeclassname="font-bold"
              onClick={toggleMenu}
            >
              Home
            </NavLink>
          </li>
          <li className="mx-8">
            <NavLink
                to="/portfolio"
                className="block py-2 pl-3 pr-4 rounded hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                activeclassname="font-bold"
                onClick={toggleMenu}
            >
                Portfolio
            </NavLink>
          </li>
          <li className="mx-8">
            <NavLink
                to="/contactMe"
                className="block py-2 pl-3 pr-4 rounded hover:bg-gray-100 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white"
                activeclassname="font-bold"
                onClick={toggleMenu}
            >
                Contact Me
            </NavLink>
          </li>
        </ul>
      </div>
    </header>
  );
  
}

export default Navbar;
